var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"value":_vm.show,"persistent":"","width":"300"}},[_c('v-card',{attrs:{"color":"white","light":""}},[_c('v-card-text',[_vm._v("\n\t\t\t"+_vm._s(_vm.message)+"\n\t\t\t"),_c('v-progress-linear',{staticClass:"mb-0",attrs:{"indeterminate":"","color":"primary"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }